module.exports = __webpack_public_path__ + "static/media/ProductImgDefault.a09d1a8f.png";